import React from 'react';
import ATSResumeTemplate from './ATSResumeTemplate';
function ATSModern(props) { return <ATSResumeTemplate {...props} variant="modern" />; }
export default ATSModern;